( function() {
	const queryParams = [
		'irclickid', //add or remove query parameters you want to transfer
	];

	// decorates the URL with query params
	function buildAllURLParams( urlToDecorate ) {
		const collectedQueryParams = [];
		for ( let queryIndex = 0; queryIndex < queryParams.length; queryIndex++ ) {
			const paramKey = queryParams[ queryIndex ];
			let paramValue = window.localStorage.getItem( 'foundr_' + paramKey );
			if ( getAllQueryParam( paramKey ) ) {
				paramValue = getAllQueryParam( paramKey );
				// collectedQueryParams.push(queryParams[queryIndex] + '=' + getAllQueryParam(queryParams[queryIndex]))
				window.localStorage.setItem( 'foundr_' + paramKey, paramValue );
			}
			if ( paramValue ) {
				urlToDecorate = ( urlToDecorate.indexOf( '?' ) === -1 ) ? urlToDecorate : urlToDecorate + '&';
				collectedQueryParams.push( queryParams[ queryIndex ] + '=' + paramValue );
			}
		}
		return urlToDecorate + collectedQueryParams.join( '&' );
	}

	// borrowed from https://stackoverflow.com/questions/831030/
	// a function that retrieves the value of a query parameter
	function getAllQueryParam( name ) {
		if ( name = ( new RegExp( '[?&]' + encodeURIComponent( name ) + '=([^&]*)' ) ).exec( window.location.search ) ) {
			return decodeURIComponent( name[ 1 ] );
		}
	}

	// your page initialization code here
	// the DOM will be available here
	const oncehubEl = document.querySelectorAll( '[data-foundrid="oncehub-embed"]' );

	if ( oncehubEl ) {
		for ( let index = 0; index < oncehubEl.length; index++ ) {
			const element = oncehubEl[ index ];
			const params = buildAllURLParams( '' );

			if ( params ) {
				element.setAttribute( 'data-so-qry-prm', buildAllURLParams( '' ) );
			}
		}
	}

	/*
	 *
	 * This script add clickid url parameter in all a tag.
	 */
	const domainsToDecorate = [
		'foundr.com', //add or remove domains (without https or trailing slash)
		'checkout.foundr.com', //add or remove domains (without https or trailing slash)
	];
	// do not edit anything below this line
	const links = document.querySelectorAll( 'a' );

	// check if links contain domain from the domainsToDecorate array and then decorates
	for ( let linkIndex = 0; linkIndex < links.length; linkIndex++ ) {
		for ( let domainIndex = 0; domainIndex < domainsToDecorate.length; domainIndex++ ) {
			if ( links[ linkIndex ].href.indexOf( domainsToDecorate[ domainIndex ] ) > -1 && links[ linkIndex ].href.indexOf( '#' ) === -1 ) {
				links[ linkIndex ].href = decorateUrl( links[ linkIndex ].href );
			}
		}
	}
	// decorates the URL with query params
	function decorateUrl( urlToDecorate ) {
		const collectedQueryParams = [];
		for ( let queryIndex = 0; queryIndex < queryParams.length; queryIndex++ ) {
			const paramKey = queryParams[ queryIndex ];
			let paramValue = window.localStorage.getItem( 'foundr_' + paramKey );
			if ( getQueryParam( paramKey ) ) {
				paramValue = getQueryParam( paramKey );
				// collectedQueryParams.push(queryParams[queryIndex] + '=' + getQueryParam(queryParams[queryIndex]))
				window.localStorage.setItem( 'foundr_' + paramKey, paramValue );
			}
			if ( paramValue && ! /[?&]irclickid=/.test( urlToDecorate ) ) {
				urlToDecorate = ( urlToDecorate.indexOf( '?' ) === -1 ) ? urlToDecorate + '?' : urlToDecorate + '&';
				collectedQueryParams.push( queryParams[ queryIndex ] + '=' + paramValue );
			}
		}
		return urlToDecorate + collectedQueryParams.join( '&' );
	}

	// borrowed from https://stackoverflow.com/questions/831030/
	// a function that retrieves the value of a query parameter
	function getQueryParam( name ) {
		if ( name = ( new RegExp( '[?&]' + encodeURIComponent( name ) + '=([^&]*)' ) ).exec( window.location.search ) ) {
			return decodeURIComponent( name[ 1 ] );
		}
	}
}() );
